<template>
  <div>
    <v-card>
      <v-container grid-list-lg>
        <v-layout class="ma-2" align-center="align-center" justify-center row>
          <div class="text-center">
            <h1 class="headline">You got the software, how about getting Hardware</h1>
            <div class="text-center mt-3">
              <div>Why not get hardware for your software?</div>
              <div>
                CellSmart POS software works with any printer/scanner but our hardware is optimized
                to work best with our software.
              </div>
              <div>
                All of our hardware comes with a
                <span class="red--text font-weight-medium">3 month replacement warranty.</span>
              </div>
              <div class="display-2 mt-3 mb-3">
                Orders over $400 qualify for
                <span class="red--text font-weight-medium">free shipping. </span>
              </div>
              <div class="mt-2 font-weight-medium">
                Below are some of our bundled packages and individual items:
              </div>
            </div>
          </div>
        </v-layout>
        <v-layout
          class="mt-5"
          v-if="isloading"
          align-center="align-center"
          justify-center
          column
          fill-height="fill-height"
        >
          <v-progress-circular size="70" width="7" color="purple" indeterminate="indeterminate">
          </v-progress-circular>
          <div class="mt-2">Loading Hardware ...</div>
        </v-layout>
        <div v-if="!isloading">
          <v-layout class="mt-5">
            <h3 class="h3-header">Packages</h3>
          </v-layout>
          <v-layout row wrap>
            <v-flex
              xs12
              sm4="sm4"
              md3="md3"
              v-for="(item, index) in hardware"
              v-if="item.productID === 36 || item.productID === 37 || item.productID === 38"
            >
              <v-card hover="hover" :class="{ selected: item.order <= 1 }">
                <v-container>
                  <h5 class="h5-header">{{ item.productDetail }}</h5>
                  <div class="text-center mt-3 mb-2">
                    <img :src="item.imageUrl" width="85" />
                  </div>
                  <div class="text-right">
                    <h5 class="h5-header">{{ item.amount | currency }}</h5>
                  </div>
                </v-container>
                <v-card-actions>
                  <v-chip v-if="item.order <= 1" color="green" text-color="white">{{
                    item.order
                  }}</v-chip>
                  <v-spacer> </v-spacer>
                  <v-btn
                    color="info"
                    v-if="item.order <= 1"
                    icon
                    small
                    outline="outline"
                    fab="fab"
                    @click="remove(index)"
                  >
                    <v-icon>remove</v-icon>
                  </v-btn>
                  <v-btn color="info" icon small outline="outline" fab="fab" @click="add(index)">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
          <v-divider> </v-divider>
          <v-layout class="mt-3" row wrap>
            <v-flex
              xs12
              sm4="sm4"
              md3="md3"
              v-for="(item, index) in hardware"
              v-if="item.productID !== 36 &amp; item.productID !== 37 &amp; item.productID !== 38"
            >
              <v-card hover="hover" :class="{ selected: item.order <= 1 }">
                <v-container>
                  <h5 class="h5-header">{{ item.productDetail }} {{ item.productID }}</h5>
                  <div class="text-center mt-3 mb-2">
                    <img :src="item.imageUrl" width="85" />
                  </div>
                  <div class="text-right">
                    <h5 class="h5-header">{{ item.amount | currency }}</h5>
                  </div>
                </v-container>
                <v-card-actions>
                  <v-chip v-if="item.order <= 1" color="green" text-color="white">{{
                    item.order
                  }}</v-chip>
                  <v-spacer> </v-spacer>
                  <v-btn
                    color="info"
                    v-if="item.order <= 1"
                    icon
                    small
                    outline="outline"
                    fab="fab"
                    @click="remove(index)"
                  >
                    <v-icon>remove</v-icon>
                  </v-btn>
                  <v-btn color="info" icon small outline="outline" fab="fab" @click="add(index)">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
          <v-divider class="mt-2"> </v-divider>
          <v-card-actions class="mt-3">
            <v-layout row wrap>
              <div>
                <h1 class="h1-header">Total {{ hardwareTotal | currency }}</h1>
                <h6 class="h6-header" v-if="hardwareTotal <= 399">
                  Shipping {{ shipping | currency }}
                </h6>
                <h6 class="h6-header" v-else>Shipping Free</h6>
              </div>
              <v-spacer> </v-spacer>
              <v-btn color="info" large text @click="removeDeal">{{
                $t("buttons.noThanks")
              }}</v-btn>
              <v-btn color="info" large @click="save" :disabled="hardwareTotal === 0">{{
                $t("buttons.addtoCart")
              }}</v-btn>
            </v-layout>
          </v-card-actions>
        </div>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      total: 0,
      name: "Hardware",
      isloading: true
    };
  },
  methods: {
    ...mapActions("location", ["order", "removeDeal", "initHardware", "addItem", "removeItem"]),
    add(index) {
      this.addItem(index);
    },
    remove(index) {
      this.removeItem(index);
    },
    save() {
      this.order({
        order: this.name,
        price: this.hardwareTotal
      });
    }
  },
  mounted() {
    this.initHardware().then(() => {
      this.isloading = false;
    });
  },
  computed: {
    ...mapGetters("location", ["hardware", "hardwareTotal", "shipping"])
  }
};
</script>

<style scoped>
.selected {
  border-width: 3px;
  border-color: orange;
  border-radius: 6px;
  -moz-border-radius: 6px;
  -webkit-border-radius: 6px;
}
</style>
